import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useEffect, useState } from "react";
import { Loader2 } from "lucide-react";
import { authClient } from "@/lib/auth/auth-client";
import { getMyRoles } from "@/server/auth-access.functions";

export const Route = createFileRoute("/admin/dashboard")({
  component: AdminDashboardGate,
});

function AdminDashboardGate() {
  const navigate = useNavigate();
  const [denied, setDenied] = useState(false);
  useEffect(() => {
    let cancelled = false;
    (async () => {
      const { data } = await authClient.getSession();
      const user = data?.user;
      if (cancelled) return;
      if (!user) { navigate({ to: "/login/admin" }); return; }
      const roles = await getMyRoles();
      const ok = roles.includes("admin");
      if (cancelled) return;
      if (!ok) {
        await authClient.signOut();
        setDenied(true);
        setTimeout(() => navigate({ to: "/login/admin" }), 1500);
        return;
      }
      navigate({ to: "/dashboard/admin" });
    })();
    return () => { cancelled = true; };
  }, [navigate]);
  return (
    <div className="min-h-screen flex items-center justify-center text-muted-foreground gap-2 px-4 text-center">
      {denied ? <p className="text-sm">This account does not have admin access. Redirecting…</p>
        : (<><Loader2 className="h-4 w-4 animate-spin" /> Verifying admin access…</>)}
    </div>
  );
}
